import {Injectable} from 'ng-metadata/core';
import{AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

const moment= require('moment');

@Injectable()
export class ShortLoanRequest extends AbstractRequest {

	constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ){
		super();
		this.formFields = [
			{
				key: 'date',
				name: 'date',
                path: 'time-slots',
				label: 'shortloan.date',
				mandatory: true,
 				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
				uiType: FormBuilderEnums.UI_TYPE.DATE,
                populator:  {
                    func:       this.datePopulator.bind(this),
                    params:     {
                        path: 'dates'
                    }
                },
				events: {
					onChange: this.onChange.bind(this),
					params: []
				}
			},
            {
                key: 'time',
                name: 'slot_id',
                path: 'time-slots',
                label: 'shortloan.hour',
                mandatory: true,
                dependOn: {key : 'date', isExists : true},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                populator:  {
                    func:       this.timeSlotPopulator.bind(this),
                    params:     {
                        display: true,
                        key: 'slot-id',
                        value:'req-slot',
                        func: this.createOption.bind(this)

                    }
                },
                style: {
                    layout: 'column'
                }
            }


		];

	}

    protected createOption(field, data) {
        let value = data[field.populator.params.key];
        let start = data[field.populator.params.value].slotstart.hour;
        let end = data[field.populator.params.value].slotend.hour;
        let startHour = moment(start, 'HHmm').format('HH:mm');
        let endHour = moment(end, 'HHmm').format('HH:mm');
        let label = startHour +' - '+endHour;
        let option = {label:label ,value:value};
        if ((end !== '0000') && parseInt(start) > parseInt(end)) {
           option.info = 'nui.shortloan.note';
        }
        console.log('value ' +value);
        return option;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/shortLoanRequest.ts